export function ConfigurationTabHeader() {
  return (
    <div className="min-w-0">
      <div className="flex items-center gap-2.5 flex-wrap">
        <h1 className="text-2xl font-bold text-slate-900">Leave Configuration</h1>
        <span className="rounded-full bg-teal-50 px-2.5 py-0.5 text-xs font-semibold text-[#146971] border border-teal-200">
          System Level Settings
        </span>
      </div>
      <p className="text-sm text-slate-500 mt-1">
        Configure attendance rules, leave policies, and employee eligibility.
      </p>
    </div>
  )
}
